import { render } from "./coverage_modal.vue?vue&type=template&id=39b11cd9"
import script from "./coverage_modal.vue?vue&type=script&lang=js"
export * from "./coverage_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__